import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=e0239a1c&lang=less&scoped=true"

import exportComponent from "C:\\Users\\mengx\\Desktop\\公司项目\\王文佳12\\王文佳公司项目\\图书馆_医信源_整理\\图书馆_公司内部项目\\妥示\\头条_H5\\digestive-realm-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0239a1c"]])

export default __exports__